import React, { useState } from 'react';
import { RiAlertFill } from 'react-icons/ri';
import AuthButton from '../AuthButton/AuthButton';
import { useSelector } from 'react-redux';
import Loader from '../Loader/Loader';
const ActiveModal = ({ isOpen, onClose, onConfirm }) => {
  const { subLoader } = useSelector(state => state.userReducer);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-gray-800 opacity-50 fixed inset-0"></div>

      <div className="bg-white rounded-lg px-3 pt-3 z-10 max-w-lg w-full shadow-lg sm:mx-5 md:mx-0">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Status Change</h3>
        <div className="text-center">
          <div className="mb-4">
            <span className="inline-flex items-center justify-center p-3 bg-red-100 rounded-full">
              <RiAlertFill className="w-6 h-6 text-red-600" /> {/* Use the alert icon */}
            </span>
          </div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Are you sure?</h2>
          <p className="text-gray-500 mb-6 w-[70%] ml-[15%]">
            Do you really want to change the status of this client?
          </p>

          <div className="flex justify-end space-x-4 " style={{

            paddingBottom: subLoader ? 12 : 0
          }}>
            {subLoader ?
              <Loader />
              :
              <>
                <AuthButton
                  className="bg-white px-4  border border-gray-300 rounded-md hover:bg-gray-100"
                  width={'20%'}
                  title={'No'}
                  onClick={onClose}
                />

                <AuthButton
                  onClick={onConfirm}
                  width={'20%'}
                  title={'Yes'}
                  className="bg-red-600 hover:bg-red-700 text-white  px-4 rounded-md"
                />
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
};
export default ActiveModal